import { render, staticRenderFns } from "./ImportPackMaterial.vue?vue&type=template&id=353fcf09&scoped=true&"
import script from "./ImportPackMaterial.vue?vue&type=script&lang=js&"
export * from "./ImportPackMaterial.vue?vue&type=script&lang=js&"
import style0 from "./ImportPackMaterial.vue?vue&type=style&index=0&id=353fcf09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353fcf09",
  null
  
)

export default component.exports